import React, { useEffect, useState } from 'react';
import ContactForm from './ContactForm';
import { useContent } from '../../hooks/useContent';
import LoadingSpinner from '../common/LoadingSpinner';
import ErrorMessage from '../common/ErrorMessage';

const ContactSection = () => {
    const { content, isLoading, isError, error, loadContentBySection } = useContent('contact');
    const [countryCode, setCountryCode] = useState('GLOBAL');

    useEffect(() => {
        const cached = localStorage.getItem('user_country');
        if (cached) {
            const data = JSON.parse(cached);
            setCountryCode(data.countryCode);
        }
    }, []);

    // Get the contact content data
    const contactData = content.length > 0 ? content[0].content_data : null;

    if (isLoading) {
        return (
            <section id="contact" className="contact-area bg-gray ptb_100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <LoadingSpinner size="lg" />
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    if (isError) {
        return (
            <section id="contact" className="contact-area bg-gray ptb_100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <ErrorMessage error={error} onRetry={() => loadContentBySection('contact')} />
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    if (!contactData) {
        return (
            <section id="contact" className="contact-area bg-gray ptb_100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="text-center">
                                <p>No contact content available.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    // Determine phone number based on country
    const phone = countryCode === 'IN' ? '+91 6304649952' : '+1 (571) 539-8071';

    return (
        <section id="contact" className="contact-area bg-gray ptb_100">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-10 col-lg-8">
                        {/* Section Heading */}
                        <div className="section-heading text-center">
                            <h2 className="text-capitalize">{contactData.heading}</h2>
                            <p className="d-none d-sm-block mt-4">{contactData.headingText}</p>
                            <p className="d-block d-sm-none mt-4">{contactData.headingTexttwo}</p>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-between">
                    <div className="col-12 col-md-5">
                        {/* Contact Us */}
                        <div className="contact-us">
                            <p className="mb-3">{contactData.headingText}</p>
                            <ul>
                                {/* Hide address, show phone based on country */}
                                <li className="py-2">
                                    <a className="media" href={`tel:${phone}`}>
                                        <div className="social-icon mr-3">
                                            <i className="fas fa-phone" />
                                        </div>
                                        <span className="media-body align-self-center">{phone}</span>
                                    </a>
                                </li>
                                <li className="py-2">
                                    <a className="media" href={`mailto:${contactData.contactInfo.email}`}>
                                        <div className="social-icon mr-3">
                                            <i className="fas fa-envelope" />
                                        </div>
                                        <span className="media-body align-self-center">{contactData.contactInfo.email}</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 pt-4 pt-md-0">
                        <ContactForm />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactSection;